export const regInteger = /^[1-9][\d]*$/;
export const regNumber = /^[0-9][\d]*(\.[\d]{1,2})?$/;
export const regHasIntegerBlank = /^[0-9 ]*$/;
